// Generated by purs version 0.15.15
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Record from "../Record/index.js";
import * as Record_Extra from "../Record.Extra/index.js";
import * as Type_Data_Boolean from "../Type.Data.Boolean/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var sequenceRecord = /* #__PURE__ */ Record_Extra.sequenceRecord();
var maybeGet$primeTrue = function (dictIsSymbol) {
    var get = Record.get(dictIsSymbol)();
    return function () {
        return {
            "maybeGet'": (function () {
                var $48 = get(Type_Proxy["Proxy"].value);
                return function ($49) {
                    return Data_Maybe.Just.create($48($49));
                };
            })()
        };
    };
};
var maybeGet$primeFalse = {
    "maybeGet'": function (v) {
        return Data_Maybe.Nothing.value;
    }
};
var rsequence = function () {
    return function (dictApplicative) {
        return function (dictSequenceRecord) {
            return sequenceRecord(dictSequenceRecord);
        };
    };
};
var rsequence1 = /* #__PURE__ */ rsequence();
var rsequence2 = function (dictFunctor) {
    return function () {
        return function (dictApplicative) {
            var rsequence3 = rsequence1(dictApplicative);
            return function (dictSequenceRecord) {
                var rsequence4 = rsequence3(dictSequenceRecord);
                return function () {
                    return function (dictApplicative1) {
                        var map = Data_Functor.map((dictApplicative1.Apply0()).Functor0());
                        var rsequence5 = rsequence1(dictApplicative1);
                        return function (dictSequenceRecord1) {
                            var $50 = map(rsequence4);
                            var $51 = rsequence5(dictSequenceRecord1);
                            return function ($52) {
                                return $50($51($52));
                            };
                        };
                    };
                };
            };
        };
    };
};
var rowListIntersection = function () {
    return function () {
        return function () {
            return function () {
                return function (dictIsBoolean) {
                    var reflectBoolean = Type_Data_Boolean.reflectBoolean(dictIsBoolean);
                    return function (x) {
                        return function (y) {
                            var $44 = reflectBoolean(Type_Proxy["Proxy"].value);
                            if ($44) {
                                return x;
                            };
                            return y;
                        };
                    };
                };
            };
        };
    };
};
var rliNilYS = {};
var rliNilXS = {};
var rliNilNil = {};
var rliMatch = function () {
    return function () {
        return {};
    };
};
var rliConsCons = function () {
    return function () {
        return function () {
            return function () {
                return function () {
                    return {};
                };
            };
        };
    };
};
var maybeGet$prime = function (dict) {
    return dict["maybeGet'"];
};
var maybeGet1 = function () {
    return function (dictMaybeGet$prime) {
        return {
            maybeGet: maybeGet$prime(dictMaybeGet$prime)
        };
    };
};
var maybeGet = function (dict) {
    return dict.maybeGet;
};
var mapFieldRecordNil = {
    mapFieldRecordImpl: function (v) {
        return function (v1) {
            return function (v2) {
                return {};
            };
        };
    }
};
var mapFieldRecordImpl = function (dict) {
    return dict.mapFieldRecordImpl;
};
var mapFieldRecordCons = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    var get = Record.get(dictIsSymbol)();
    var insert = Record.insert(dictIsSymbol)()();
    return function () {
        return function (dictMapFieldRecord) {
            var mapFieldRecordImpl1 = mapFieldRecordImpl(dictMapFieldRecord);
            return function () {
                return function () {
                    return {
                        mapFieldRecordImpl: function (v) {
                            return function (f) {
                                return function (r) {
                                    var rest = mapFieldRecordImpl1(Type_Proxy["Proxy"].value)(f)(r);
                                    var val = f(reflectSymbol(Type_Proxy["Proxy"].value))(get(Type_Proxy["Proxy"].value)(r));
                                    return insert(Type_Proxy["Proxy"].value)(val)(rest);
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var mapFieldRecord = function () {
    return function (dictMapFieldRecord) {
        return mapFieldRecordImpl(dictMapFieldRecord)(Type_Proxy["Proxy"].value);
    };
};
export {
    rsequence,
    rsequence2,
    mapFieldRecordImpl,
    mapFieldRecord,
    maybeGet,
    maybeGet$prime,
    rowListIntersection,
    mapFieldRecordCons,
    mapFieldRecordNil,
    maybeGet1,
    maybeGet$primeTrue,
    maybeGet$primeFalse,
    rliNilXS,
    rliNilYS,
    rliNilNil,
    rliMatch,
    rliConsCons
};
